/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRegressionModel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2v20h20v-2H5.466a42.25 42.25 0 0 0 2.016-1.039c2.198-1.208 4.946-2.975 7.225-5.254 2.353-2.352 3.915-4.96 4.89-7.106a21.21 21.21 0 0 0 1.059-2.814C20.87 3.048 21 2.4 21 2h-2c0 .099-.058.514-.265 1.229-.197.68-.509 1.556-.958 2.545-.9 1.978-2.337 4.371-4.484 6.519-2.094 2.093-4.662 3.755-6.775 4.916-.978.537-1.85.963-2.518 1.27V2zm10 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5.937 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM18 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRegressionModel as RegressionModel };
